import { useSelector, useStore } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as AppMapping from '../store/actions/app'

import theme from '../theme'

export const useAppSnackbars = () => {
    const store = useStore()
    const app = bindActionCreators(AppMapping, store.dispatch)
    const appStore = useSelector(state => state.app.snackbars)
    const position = { position: 'fixed', top: '24px', right: '24px', zIndex: theme.zIndex.dpHeader }

    const stack = (id, message, mode = 'info', duration = 5000) => {
        const data = store.getState().app?.snackbars ?? []

        const item = {
            id: id,
            message: message,
            mode: mode
        }

        data.push(item)
        app.stackSnackbar(data)

        setTimeout(hideSingle(item), duration)
    }

    const hideSingle = (item) => () => {
        const data = store.getState().app?.snackbars ?? []
        const newData = []

        for (let i = 0; i < data.length; i++) {
            if (data[i].id === item.id) continue
            newData.push(data[i])
        }

        app.stackSnackbar(newData)
    }

    return { stack, hideSingle, config: { items:appStore, position: position }}
}